import { createContext } from 'react';
import IPlatformConfig from '../model/IPlatformConfig';

const PlatformJsonnetContext = createContext<IPlatformConfig>(null);

export default PlatformJsonnetContext;
